import { useNavigate } from "react-router-dom";

const ViewPayments = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="main_title">
        <h1>Transaction Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate(-1)}>
            Transactions & Loyalty Logs
          </button>{" "}
          - Transaction Detail
        </p>
      </div>

      {/* promotion Info */}

      <div className="cards view_page">
        <ul className="order_head mb_20">
          <li>
            <h6>Receipt ID:</h6>
            <p>1009826</p>
          </li>
          <li>
            <h6>Transaction Date & Time:</h6>
            <p>01 Nov 2024, 04:36 PM</p>
          </li>
          <li className="ml_auto">
            <span className="btn_text dark c_success">Earned</span>
          </li>
        </ul>
        <div className="gap_p">
          <div className="w_33">
            <h6>User Details</h6>
            <p>
              Sophia Williams <br /> 9876543210 <br /> sophia@yopmail.com{" "}
            </p>
          </div>
          <div className="w_33">
            <h6>Loyalty Points</h6>
            <span className="btn_text sm c_success">+ 100</span>
          </div>
          <div className="w_33">
            <h6>Source</h6>
            <p>Store - Jumeirah</p>
          </div>
          <div className="w_100">
            <h6>Store Address</h6>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Error, a!
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewPayments;
